import { useEffect } from "react";
import { useQueryClient } from "react-query";
import { useStoreLocation } from "../context/StoreLocation";
import { useAuthState } from "../context/UserAuthentication";
import { prefetchMenuOnAppLoad } from "../react-query-hooks/LocationMenu/useMenuPrefetch";
import useGetTags from "../react-query-hooks/useGetTags";

const LocationMenuController = () => {
    const { authInfo } = useAuthState();
    const { locationInfo } = useStoreLocation();
    const location_id = locationInfo.selectedStore?.id;
    const queryClient = useQueryClient();

    useEffect(() => {
        prefetchMenuOnAppLoad(queryClient, location_id, authInfo);
    }, [location_id]);
    useGetTags();

    return null; // This component is invisible
};

export default LocationMenuController;